export default class InvoiceRejection {
  id = 0;
  reason = "";
  remark = "";
  document: File | null = null;
  documentID = 0;
  documentName = "";
  documentLink = "";
}
